import type { FaireProductEntity } from "../../entity_types/product";

export const p_63y96wr9td: FaireProductEntity = {
  token: "p_63y96wr9td",
  type: "product",
  name: "Les Anis de Flavigny Organic Ginger Flavored Mints 1.8oz",
  brandToken: "b_9anqzdvs32",
  brandName: "The French Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/e7d4092433d399abf567901f510e23fc86837c96b139de36ed15907626f1c3f7.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.79,
  description:
    "Ginger is among our most surprising and potent flavors. Ginger-lovers beware, these sweets are zingy and wonderfully spicy!&nbsp;Each candy contains organic aniseed in its center coated with thin layers of organic cane sugar and all-natural flavoring. Ingredients: sugar*, natural ginger flavoring with other natural flavorings, green aniseed*(0,2%) *: Product from the organic agriculture",
  tags: [],
  msrpDollars: 11.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:46.793Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
